// middleware/auth.ts
// Middleware de navigation Nuxt (client-side uniquement, routes ssr:false).
// À appliquer sur les pages protégées via : definePageMeta({ middleware: 'auth' })

import { getMsalActiveAccountEmail, hydrateUserStoreFromMsalIfNeeded } from '~/utils/msalUtils'
import { TempUserSession } from '~/utils/tempUserSession'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!import.meta.client) return

  await hydrateUserStoreFromMsalIfNeeded()
  await new Promise<void>((resolve) => queueMicrotask(resolve))
  await hydrateUserStoreFromMsalIfNeeded()

  // Temp user (tunnel SEA) : restaure cookie + profil, sinon reload d'une page protégée → /login.
  const fallbackEmail: string | null = await getMsalActiveAccountEmail()
  await TempUserSession.syncProfileFromMe(fallbackEmail)

  const userStore = useUserStore()
  if (userStore.isLoggedIn) {
    return
  }

  return navigateTo(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
})
